<template>
  <div class="container">
    <child />
  </div>
</template> 
 
<script>
  import "@/assets/scss/main.scss";
  export default {
    name: "Default"
  };
</script> 